var miniworldHouseCommunication = new(function() {
	var wrapResponse = function(successHook) {
		return function(response) {
			response.data.settings = JSON.parse(response.data.settings);
			successHook(response);
		};
	};

	this.loadFirstRoom = function(ownerId, successHook) {
		axios("/ajaj/games/miniworldHouseInside/loadfirstroom", {
			method: 'get',
			params: { id: ownerId }
		}).then(wrapResponse(successHook));
	};

	this.loadRoom = function(roomId, successHook) {
		axios("/ajaj/games/miniworldHouseInside/loadroom", {
			method: 'get',
			params: { miniworldRoom: roomId }
		}).then(wrapResponse(successHook));
	};

	this.saveRoom = function(representation, successHook) {
		axios('/ajaj/games/miniworldHouseInside/saveroom', {
			method: 'post',
			headers: { 'content-type': 'application/x-www-form-urlencoded' },
			data: {
				miniworldRoomId: representation["id"],
				miniworldRoomName: representation["name"],
				miniworldRoomSettings: representation["settings"],
				miniworldRoomDoors: JSON.stringify(representation["doors"]),
				miniworldRoomItems: JSON.stringify(representation["items"])
			}
		}).then(successHook);
	};

	this.userHasEnoughMoneyToBuyRoom = function(successHook) {
		axios("/ajaj/games/miniworldHouseInside/userhasenoughmoneytobuydoor", {
			method: 'get'
		}).then((response) => {
			successHook(response.data.ans, response.data.message);
		});
	};

	this.buyDoor = function(roomId, doorPosition, doorColor, successHook) {
		axios("/ajaj/games/miniworldHouseInside/buydoor", {
			method: 'get',
			params: {
				miniworldRoom: roomId,
				miniworldDoorPosition: doorPosition,
				miniworldRoomDoorColor: doorColor
			}
		}).then((response) => {
			if (response.data.success) {
				successHook(response.data.roomid);
			}
		});
	};

	this.storeItemInInventory = function(itemId) {
		axios("/ajaj/games/miniworldHouseInside/storeItemInInventory", {
			method: 'get',
			params: {
				miniworlditeminstanceid: itemId
			}
		});
	};

	this.storeItemInRoom = function(roomId, item) {
		axios("/ajaj/games/miniworldHouseInside/storeItemInRoom", {
			method: 'get',
			params: {
				miniworldRoom: roomId,
				miniworldRoomItem: JSON.stringify({
					"instanceid": item.instanceid,
					"positionx": item.positionx,
					"positiony": item.positiony
				})
			}
		});
	};

	this.deleteItem = function(itemId, currentItemCategory) {
		axios("/ajaj/games/miniworldHouseInside/deleteItemInstance", {
			method: 'get',
			params: {
				miniworlditeminstanceid: itemId
			}
		}).then((response) => {
			if (currentItemCategory != null) {
				InventoryListInstance.filterForCategory(currentItemCategory);
			}
		});
	};

	this.deleteRoom = function(roomId) {
		axios("/ajaj/games/miniworldHouseInside/deleteroom", {
			method: 'get',
			params: { miniworldRoom: roomId }
		});
	};

});
